export default () => {
  const burgerMenu = document.querySelector('.js-burger')
  const headerPanel = document.querySelector('.header__panel')
  const mobileMenuLinks = document.querySelectorAll('.menu--mobile .menu__item')

  burgerMenu.addEventListener('click', () => {
    burgerMenu.classList.toggle('burger--active')
    headerPanel.classList.toggle('header__panel--active')
  })

  mobileMenuLinks.forEach(menuLink => {
    menuLink.addEventListener('click', () => {
      burgerMenu.classList.remove('burger--active')
      headerPanel.classList.remove('header__panel--active')
    })
  })
}